<script>


import PlanExtraHoursPanel from "./PlanExtraHoursPanel.vue";
import StripePrice from "/vodalys2023/stripe/main/components/StripePrice.vue";

export default {
  translate25Context: "plan",
  components: { StripePrice },
  props: ["component", "handler"],
  data: function () {
    return {
      count: this.component.stripe_component.quantity ?? 2,
      stripePending: false
    };
  },
  methods: {
    async gotAddress(address) {
      console.log('gotAddress', address)
      const { '#result': taxObject } = await this.handler.action(this.component, 'calculate_tax', [address.address, this.count])
      const { '#result': invoiceObject } = await this.handler.action(this.component, 'preview_invoice', [address.address, this.count])

      console.log('taxObject', taxObject)
      console.log('invoiceObject', invoiceObject)
    },
    async purchase(address) {

      console.log('purchase purchase purchase', address)

      const { '#result': { clientSecret } } = await this.handler.action(this.component, 'purchase', [address])

      console.warn('result', clientSecret)

      // console.log('intent', intent)

      // const { clientSecret } = intent

      // console.log('clientSecret', clientSecret)

      return clientSecret

    },
    async buyForFree(count) {
      await this.handler.action(this.component, 'buy_for_free', [count])
      location.hash = '#/purchase#thank-you'
    }
  },
  computed: {},
  mounted() {
    this.count = this.component.stripe_component.quantity ?? 1
  }
}
</script>

<template>
  <div class="plan-extra-hours">
    <f-sexy-scroll>
      <div class="div plan-extra-hours-title">{{$vt("Proceed to payment")}}</div>
      <div class="plan-extra-hours-content" v-if="component.stripe_component && component.hour_price">
        <div class="plan-extra-hours-left">
          <PlanExtraHoursPanel :hour-price="component.hour_price" :count.sync="count"
            :count-editable="!stripePending" />
          <f-button class="plan-extra-hours-left-back" type="link" href="#"><f-icon icon="fa6-arrow-left"></f-icon>
            Back</f-button>
        </div>
        <div class="plan-extra-hours-right">
          <StripeLoader :component="component.stripe_component" :handler="handler" :quantity="count" />
        </div>
        <FButton v-if="component['#actions']['buy_for_free']" @click="buyForFree(count)" type="danger"
          style="writing-mode: vertical-rl;">
          Buy for free</FButton>
      </div>
      <div v-else>
        <FHint icon="fa6-warning" type="negative">
          <template #title>
            Unable to purchase additional hours at this time
          </template>
          <template #message>
            Please review your subscription plan status
          </template>
          <template #action>
            <f-button class="plan-extra-hours-left-back" type="link" href="#"><f-icon icon="fa6-home"></f-icon>Back
            </f-button>
          </template>
        </FHint>
      </div>
    </f-sexy-scroll>

  </div>
</template>

<style lang="scss">
.plan-extra-hours {
  height: 100%;
  width: 100%;

  .f-sexy-scroll {
    height: 100%;
    display: flex;
    justify-content: center;
    width: 100%;

    .f-sexy-scroll-inner {
      padding: 64px 0;
      box-sizing: content-box;
      display: flex;
      flex-direction: column;
      gap: 32px;
    }
  }

  .plan-extra-hours-title {
    color: var(--white-a75);
    text-align: center;
    font-family: Lato;
    font-size: 48px;
    font-style: normal;
    font-weight: 700;
    line-height: 110%;
    /* 52.8px */
  }



  .plan-extra-hours-content {
    display: flex;
    gap: 32px;
    flex: 1 1 auto;

    padding-bottom: 64px;

    .plan-extra-hours-left {
      display: flex;
      flex-direction: column;
      gap: 16px;
      height: 100%;

      .plan-extra-hours-left-back {
        color: var(--white-a75);
        text-align: center;
        font-family: Lato;
        font-size: 24px;
        font-style: normal;
        font-weight: 700;
        line-height: 110%;
      }
    }

    .plan-extra-hours-right {
      width: 950px;
    }
  }
}
</style>